<!--&lt;!&ndash;我的钱包&ndash;&gt;-->
<template>
  <div class="totalList_container">
    <Row :span="24">
      <div style="display: flex;margin:0 auto">
        <Col style="width:50%;margin-top:20px;margin:0 auto;">
          <div class="box" style="margin-top:40px;margin-left:1%">
            <p style="display: flex;">
              <span class="title">账户余额：</span>
              <span class="balance" style="color:#ff0000;margin-left:80px;margin-top:5px;">{{asset.balance | moneyFilter}}</span>
            </p>
            <p style="display: flex;margin-top:-50px;">
              <span class="title" style="font-size:18px;">冻结金额：</span>
              <span class="balance" style="font-size:18px;color:#0000ff;margin-left:95px;margin-top:8px;">{{asset.freezeMoney | moneyFilter}} </span>
            </p>
          </div>
          <div style="width:90%;margin:0 auto;margin-left:1%;">
            <p style="display: flex;margin-top:22px;">
              <my-button  style="background:#ff0000;width:50%;">充值</my-button>
              <my-button @confirm=" withdrawal" style="background:#008000;width:50%">提现</my-button>
            </p>
          </div>
        </Col>
        <Col style="width:50%;">
          <div style="height:320px;">
            <span style="font-size:20px;">保理分布图</span>
            <echarts style="width: 100%;height: 260px;
          border:1px solid rgb(180,180,180);" id="echarts"></echarts>
          </div>
        </Col>
      </div>
    </Row>
    <Form ref="form"  inline>
      <Row>
        <Col span="24">
          <Table border :columns="columns" :data="pagination.items"></Table>
        </Col>
      </Row>
    </Form>
    <div class="pagination-list" id="pagination-list">
      <Page
        :total="pagination.total" show-total show-sizer class-name="pagination"
        @on-change="pageChange"
        :page-size-opts="[10,20,30]"
        :page-size="10"
        :current="pagination.page"
        @on-page-size-change="changeSize">
      </Page>
      <Button style="background:#2975E6;color:#ffFFFF;border:0;" @click="handleDownload">导出Excel</Button>
    </div>
  </div>
</template>
<script>
  import ApiClient from '@/api/ApiClient'
  import MyButton from '@/components/MyButton'
  import Echarts from '@/components/Echarts'
  export default {
    components: {MyButton,Echarts},
    name: 'walletIndex',
    activated: function() {
      this.initData();
      this.fetchData();
    },
    data() {
      return {
        cardList: [],
        asset: {
          balance:'',
          freezeMoney: ''
        },
        table:{
          page:1,
          size:10,
          state:'',
          withdrawId: ''
        },
        pagination:{},
        columns:[
          {
            align:'center',
            title:'提现金额',
            key:'amount',
            minWidth:10,
            render: (h, params) => {
              if (params.row.amount){
                return h('div', {
                },`￥${params.row.amount.toFixed(2)}`)
              } else {
                return h('div', {}, `￥${Number(0).toFixed(2)}`)
              }
            }
          },
          {
            align:'center',
            title:'提现卡号',
            key:'cardNo',
            minWidth:10,
          },
          {
            align:'center',
            title:'提现手续费',
            key:'fee',
            render: (h, params) => {
              if (params.row.fee){
                return h('div', {
                },`￥${params.row.fee.toFixed(2)}`)
              } else {
                return h('div', {}, `￥${Number(0).toFixed(2)}`)
              }
            }
          },
          {
            align:'center',
            title:'提现时间',
            key:'withdrawTime',
            minWidth:10,
            render:(h,params)=>{
              if(params.row.withdrawTime){
                return h('div', {}, this.$moment(params.row.withdrawTime).format('YYYY-MM-DD HH:mm'))
              }else{
                return
              }
            }
          },
          {
            align:'center',
            title:'审核时间',
            key:'verifyTime',
            minWidth:10,
            render:(h,params)=>{
              if(params.row.verifyTime){
                return h('div', {}, this.$moment(params.row.verifyTime).format('YYYY-MM-DD HH:mm'))
              }else{
                return
              }
            }
          },
          {
            align:'center',
            title:'状态',
            key:'state',
            minWidth:10
          },
          {
            align:'center',
            title:'操作',
            key:'action',
            render:(h,params)=>{
              return h('div',[
                h('Button',{
                  props:{
                    type:'primary',
                    size:'small'
                  },
                  on: {
                    click: () => {
                      this.$router.push({name: 'billDetails', query: {id: params.row.withdrawId}})
                    }
                  }
                },'详情')
              ])
            }
          }
        ]
      }
    },
    methods: {
      initData() {
        ApiClient.get('/desktop/profile/asset.do').then(data => {
          this.asset = data;
        });
        // ApiClient.post('/desktop/profile/cardQuery.do', {size: 9999, page: 1}, {silent: true}).then(data => {
        //   this.cardList = data.wCardQueryDataDtoList
        // })
      },
      withdrawal(){
        this.$router.push('withdraw')
      },
      fetchData(){
        ApiClient.get('/desktop/withdraw/myWithdrawList.do',this.table).then(data => {
          this.pagination=data;
        });
        ApiClient.get('/desktop/withdraw/myWithdrawList.do',Object.assign({},this.table,{page:1,size:99999999})).then(data => {
          this.excelData = data;
        });
      },
      pageChange(v) {
        this.table.page = v;
        this.fetchData()
      },
      changeSize(size) {
        this.table.size = size;
        this.fetchData()
      },
      handleDownload() {
        require.ensure([], () => {
          const { export_json_to_excel } = require('@/excel/Export2Excel')
          const tHeader = ['提现金额', '提现卡号', '提现手续费','提现时间','审核时间','状态']
          const filterVal = ['amount', 'cardNo', 'fee','withdrawTime','verifyTime','state']
          const list = this.excelData.items;
          for(let i=0;i<list.length;i++){
            list[i].withdrawTime=this.$moment(list[i].withdrawTime).format('YYYY-MM-DD HH:mm');
            list[i].verifyTime=list[i].verifyTime?this.$moment(list[i].verifyTime).format('YYYY-MM-DD'):null;
          }
          const data = this.formatJson(filterVal, list)
          export_json_to_excel(tHeader, data, '我的提现列表')
        })
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
      },
    },
    mounted() {
      this.initData();
      this.fetchData();
    },
  }
</script>
<style scoped lang="less">
  .box {
    border: 1px solid #ccc;
    border-radius: 5px;
    border-top: 3px solid #9A9A9A;
    padding: 40px 80px;
    margin-bottom: 20px;
    margin-top:30px;
    padding-top: 0;
    width:90%;
    margin:0 auto;
    .bank_name {
      margin-bottom: 20px;
    }
    .balance {
      color: #666;
      font-size: 25px;
    }
    .title {
      font-size: 20px;
      padding: 8px;
      margin: 0 -80px 0 -80px;
      margin-bottom: 50px;
    }
  }
  .bank_card_box {
    border: 1px solid #ccc;
    border-radius: 3px;
    background-color: #EFF0F1;
    padding: 20px 30px;
    cursor: pointer;
    width: 80%;
    margin-bottom: 20px;
  }
  .bank_card_box1 {
    text-align: center;
    cursor: pointer;
  }
</style>
<style lang="less" scoped>
  .totalList_container {
    .pagination-list {
      margin: 20px 0;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: end;
      -ms-flex-pack: end;
      justify-content: center
    }
    #pagination-list .pagination .ivu-page-item-active {
      background-color: transparent;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/myProfile/wallet.vue